import { getEnumTKey } from "@/utils/strings";
import { tWithFallback } from "@/utils/i18n";
import {
  ContractColumn,
  ContractTableRow,
  ContractTableStatus
} from "./types";

export const contractTableStatusColors: Record<ContractTableStatus, string> = {
  [ContractTableStatus.ACTIVE]: "var(--charts-positive)",
  [ContractTableStatus.UPCOMING]: "var(--natural)",
  [ContractTableStatus.EXPIRED]: "var(--charts-negative)",
  [ContractTableStatus.NO_SERVICES]: "var(--border-field-default)",
  [ContractTableStatus.ONE_TIME]: "var(--charts-purple-strong)",
  [ContractTableStatus.DRAFT]: "var(--border-field-default)"
};

// The badge's own text, so the Status column can group and label on what the user reads.
export const getContractStatusLabel = (
  status: ContractTableStatus,
  displayFallback?: string | null
) =>
  tWithFallback(
    getEnumTKey("contracts.table", "statusValues", ContractTableStatus, status),
    displayFallback
  );

// The Status column's accessor: grouping keys off it, and `statusResolved` is null on most accounts.
export const getContractStatusValue = (
  row: Pick<ContractTableRow, "status" | "statusResolved">
): string =>
  row.status == null
    ? ""
    : getContractStatusLabel(row.status, row.statusResolved);

// Group By offers every column a groupable filter reaches; the source deal is filtered as
// free text, and `deal_id` derives from the registry only where it sets `deals`.
export const contractsGroupByOptions = [ContractColumn.SOURCE_DEAL];

// Field Management can hide a column out from under these, and an option with no column
// is listed but never groups — the defect this list is part of fixing.
export const getVisibleContractsGroupByOptions = (
  columnIds: Iterable<string | undefined>
): string[] => {
  const present = new Set(columnIds);
  return contractsGroupByOptions.filter((id) => present.has(id));
};
